'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import _ from 'lodash'

const moment = window.moment;

export default class ECCodePage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state = { };

		this.handleSessionChange = this.handleSessionChange.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange (source)
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session.EC) return;

		component.setState(
		{
			EC_code: app.state.session.EC.code
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		var output =
		(
			<Layout page_title="Code d'inscription" history={ props.history }>

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						<div className="page-form-container">

							<div className="o-content">

								<div className="c-form-message c-form-message--green u-no-margin-top u-no-margin-bottom">
									<div className="c-form-message__content">
										Votre code d'inscription est le&nbsp;:
										<span style={{ fontWeight: '700' }}>
											{ state.EC_code ? ' ' + state.EC_code : '' }
										</span>
									</div>
								</div>

							</div>

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}